import {request} from './repository';

const url = 'procedures/';


const procedureRepository = {
    getProcedure(id) {
        return request.get(url + id);
    },
    updateProcedure(id, data) {
        return request.put(url + id, data);
    },
    updateProcedureExecution(id, data) {
        return request.put(url + `update-execution/${id}`, data)
    },
    updateMultipleServiceProcedureExecution(data) {
        return request.post('multiple/execute', data)
    },
    getAnswers(procedure) {
        return request.get(url + procedure);
    },
    printProcedure(service, id) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v1/procedure-report/${service}/${id}`, {
                headers: {
                    'accept': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                },
                responseType: 'blob'
            }).then((response) => {
                resolve(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    changeOrganization(id, data) {
        return request.put(`${url}${id}/change-organization`, data)
    },
}

export default procedureRepository;
